/**
 * @description
 * Clase para la definición de los puertos e IP's de la API
 */

export const APP_VERSION = '1.0';

export class Apisettings {
  public baseUrl: string;
  public defaultPort: number;
  public citaPreviaPort: number;
}

export let APISETTINGS: Apisettings = {
  baseUrl: '',
  defaultPort: 80,
  citaPreviaPort: 3746,
};

// funcion para generar la url base de la API
export function getBaseUrl(): string {
  let hostname: string = window.location.hostname.toString();
  let baseUrl: string;
  console.log(window.location);
  console.log(hostname);
  switch (hostname) {
    
    case 'localhost': // tussam.ayesa.link
      baseUrl = 'https://172.18.74.167:3746';
      break;
    case '172.18.73.216': // tussam.ayesa.link
      baseUrl = 'https://172.18.74.167:3746';
      break;
    case 'sevilla.org': // tussam.ayesa.link
      baseUrl = 'https://sevilla.org/citasdistritosayesa';
      break;
    case 'www.sevilla.org': // tussam.ayesa.link
      baseUrl = 'https://www.sevilla.org/citasdistritosayesa';
      break;
    case 'tussam.ayesa.link': // tussam.ayesa.link
    baseUrl = 'https://' + hostname + '/apiTussam';
      break;
    case 'testcitaprevia.ayesa.link': // tussam.ayesa.link
      baseUrl = 'https://' + hostname + '/apiTest';
      break;
    case 'citaprevia_test.ayesa.link': // tussam.ayesa.link
      baseUrl = 'https://citaprevia_test_micro1.ayesa.link';
      break;
    
    case '172.18.74.167': case '172.18.74.126':
      if (window.location.protocol.toString() === 'https:') {
      baseUrl = 'https://' + hostname + ':3746';
    } else {
       baseUrl = 'http://' + hostname + ':3749';
    }
      break;
    default:
      baseUrl = 'https://' + hostname + ':3746';
  }
  console.log('BASE URL', baseUrl);
  return baseUrl;
}




